import React from "react";
import MainSubtitle from "../components/MainSubtitle";
import ParagraphLeft from "../components/ParagraphLeft";
import AboutUsInformations from "../components/AboutUsInformations";
import ParagraphRight from "../components/ParagraphRight";

function About() {
    return (
        <main>
            <MainSubtitle />
            <ParagraphLeft />
            <AboutUsInformations />
            <ParagraphRight />
        </main>
    )
}

export default About;